"use client";

import { FC } from "react";

interface Tab {
  label: string;
  value: string;
}

interface IndicesTabsProps {
  tabs: Tab[];
  selectedTab: string;
  onTabChange: (value: string) => void;
}

export const IndicesTabs: FC<IndicesTabsProps> = ({
  tabs,
  selectedTab,
  onTabChange,
}) => {
  return (
    <div className="flex gap-2 overflow-x-auto whitespace-nowrap [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {tabs.map((tab) => {
        const isActive = selectedTab === tab.value;
        return (
          <button
            key={tab.value}
            onClick={() => onTabChange(tab.value)}
            className={`shrink-0 rounded-[8px] cursor-pointer md:p-2 py-[5px] px-[8px] text-[14px] font-[400px] transition-colors ${
              isActive
                ? "bg-[#002953] text-white"
                : "border border-[#002953] bg-white text-[#002953]"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

